<!-- 工作台 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="infocontent">
            <div class="notice" v-if="notices.length > 0">
                <div class="head">
                    <img src="@/assets/images/notice.png" />
                    联盟公告
                </div>
                <el-carousel height="42px" direction="vertical" :interval="8000" indicator-position="none" autoplay>
                    <el-carousel-item v-for="(item, index) in notices" :key="index">
                        <div class="li">
                            <div class="top">
                                <div class="title">{{ item.Title }}</div>
                                <div class="date">发布时间：{{ item.PublishTime }}</div>
                            </div>
                            <div class="content">{{ item.Content }}</div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="infocontent-1">
                <div class="up-logo">
                    <div style="width: 200px">
                        <div class="preview">
                            <img :src="showData.LogoUrl ? downloadUrl + showData.LogoUrl : ''" alt :onerror="defaultImg" />
                        </div>
                    </div>
                </div>
                <div class="formData">
                    <div class="company-title">
                        <div class="company-name">{{ showData.UnionName }}</div>
                        <div>
                            <el-button class="btn-primary" @click="showDialog()" v-if="permission.edit">{{ permission.edit }}</el-button>
                            <el-button type="danger" @click="delUnion()" v-if="permission.del">{{ permission.del }}</el-button>
                        </div>
                    </div>
                    <div class="msg-line">
                        <div class="msg-cell">
                            <div class="key">简称</div>
                            <div class="value">{{ showData.Abbr }}</div>
                        </div>
                    </div>
                    <div class="msg-line">
                        <div class="msg-cell">
                            <div class="key">主营配件</div>
                            <div class="value">{{ showData.MainManageAutoParts }}</div>
                        </div>
                        <div class="msg-cell">
                            <div class="key">主营车型</div>
                            <div class="value">
                                <div>
                                    {{ showData.MainManageSeries }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="msg-line">
                        <div class="msg-cell">
                            <div class="key">联系人</div>
                            <div class="value">
                                <div>
                                    {{ showData.Contact }}
                                </div>
                            </div>
                        </div>
                        <div class="msg-cell">
                            <div class="key"><i class="fa fa-volume-control-phone"></i>联系电话</div>
                            <div class="value">
                                <div>
                                    {{ showData.PhoneNum }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="msg-line">
                        <div class="msg-cell">
                            <div class="key">所属企业</div>
                            <div class="value">
                                {{ showData.EntpName }}
                            </div>
                        </div>
                        <div class="msg-cell">
                            <div class="key">是否开放申请</div>
                            <div class="value">{{ showData.IsCanApply ? '是' : '否' }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" title="供应商信息" :visible.sync="dialogFetchVisible" width="1000px">
                <div class="dialog-content" v-if="dialogFetchVisible">
                    <EntityEdit :releEntpId="releEntpId" :type="1" @closeDialog="closeEntityDialog" :source="2"></EntityEdit>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="关联供应商信息'" :visible.sync="dialogReleVisible" width="1000px">
                <div v-if="dialogReleVisible">
                    <ReleEntpEntity :releEntpId="releEntpId" :source="2" @closeDialog="closeReleDialog"></ReleEntpEntity>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="编辑联盟信息" :visible.sync="dialogEditVisible" width="1000px">
                <div class="dialog-content" v-if="dialogEditVisible">
                    <CreateUnion :UnionId="unionId" @closeDialog="closeEditUnionDialog"></CreateUnion>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import EntityEdit from '@/components/entpUnion/entityManage/entityEdit';
import ReleEntpEntity from '@/components/entpUnion/entityManage/releEntpEntity';
import CreateUnion from '@/components/entpUnion/entityManage/createUnion';
export default {
    name: '',
    components: {
        CreateUnion,
        breadcrumb,
        EntityEdit,
        ReleEntpEntity
    },
    data() {
        return {
            unionId: this.$util.getLocalStorage('currentUnion'),
            dialogEditVisible: false,
            booleanTrue: true,
            booleanFalse: false,
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            dialogFetchVisible: false,
            dialogReleVisible: false,
            releEntpId: '',
            showData: {},
            permission: {},
            notices: []
        };
    },
    mounted() {
        this.permission = this.$util.getUnionPermission('UnionInfoes');
        this.GetUnionDatas();
        this.GetUnionNotices();
        this.getUnionReleResults();
    },
    methods: {
        closeEditUnionDialog(edit) {
            if (edit) this.GetUnionDatas();
            this.dialogEditVisible = false;
        },
        // 获取联盟详情信息
        GetUnionDatas() {
            this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetUnionDataDetails',
                    data: {
                        UnionId: this.unionId
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.showData = data;
                });
        },
        GetUnionNotices() {
            this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetUnionShowNoticeList',
                    data: {
                        UnionId: this.unionId
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.notices = data;
                });
        },
        delUnion() {
            let that = this;
            that.$util.elConfirm({
                content: '确定要解散该联盟吗? 一旦解散则联盟数据将一起被清空，无法再恢复',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpUnions/DelUnionDatas?unionId=` + that.unionId
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg(res.errmsg);
                                that.$util.getUnionDatas(true);
                                that.$router.push('/');
                            } else that.$util.warningMsg(res.errmsg);
                        });
                }
            });
        },
        getUnionReleResults() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetUnionReleResults',
                    data: {
                        UnionId: that.unionId
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        if (!data.IsRele && !data.IsMine) {
                            that.releEntpId = data.ReleEntpId;
                            that.$confirm('您还没有对联盟拥有者进行实体关联，关联之前无法进行下单哟', '提示', {
                                confirmButtonText: '提取实体',
                                cancelButtonText: '关联实体',
                                type: 'warning',
                                center: false,
                                distinguishCancelAndClose: true
                            })
                                .then(() => {
                                    that.dialogFetchVisible = true;
                                })
                                .catch(action => {
                                    if (action === 'cancel') {
                                        that.dialogReleVisible = true;
                                    }
                                });
                        }
                    } else that.$util.warningMsg(res.errmsg);
                });
        },
        closeEntityDialog(isEdit) {
            this.dialogFetchVisible = false;
            if (isEdit) this.getUnionReleResults();
        },
        closeReleDialog(isEdit) {
            this.dialogReleVisible = false;
            if (isEdit) this.getUnionReleResults();
        },
        // 显示dialog
        showDialog(type) {
            this.dialogEditVisible = true;
        }
    }
};
</script>
<style lang="less" scoped>
.base-content {
    > div {
        margin: 0 auto;
    }
}
.tabs-btn-ctn {
    border-bottom: 1px solid @border1Color;
    .tab-btn-item {
        flex-grow: 0;
        width: 120px;
        padding: 0 10px;
        border-bottom: none;
    }
}
.base-content {
    padding-top: 20px;
}
.infocontent {
    max-width: 1200px;
    margin: 0 auto;
}
.notice {
    margin: 36px 0;
    padding: 24px 36px;
    border: 1px dashed #c0c2c4;
    border-radius: 16px;
    .head {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        font-size: 18px;
        img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
        }
    }
    .top {
        display: flex;
        justify-content: flex-start;
        .title {
            font-size: 15px;
            font-weight: 600;
            margin-right: 10px;
        }
        .date {
            color: #8d8f92;
        }
    }
    .content {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.infocontent-1 {
    display: flex;
    justify-content: space-between;
    padding: 24px 36px;
    border: 1px dashed #c0c2c4;
    border-radius: 16px;
}
.up-logo {
    // margin-top: 70px;
    width: 30%;
    min-width: 300px;
    text-align: center;
}

.preview {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
    border: 1px solid @border4Color;
    border-radius: 10px;
    display: flex;
    align-items: center;
    overflow: hidden;
    img {
        max-width: 200px;
        max-height: 200px;
    }
}

.btn-upload {
    width: 200px;
    margin-top: 20px;
}

.formData {
    margin-top: 60px;
    width: 72%;
}

.company-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.company-name {
    font-size: @font-lg;
}

.msg-line {
    display: flex;
    line-height: 36px;
    justify-content: space-between;
    border-bottom: 1px dashed @border4Color;
}

.msg-cell {
    width: 550px;
    display: flex;
    .key {
        width: 150px;
        text-align: right;
        padding-right: 20px;
        flex-shrink: 0;
    }
    .value {
        a {
            color: #606266;
        }
    }
    i {
        margin-right: 10px;
    }
}
.quill-editor {
    height: 200px;
}
.companyIntr-title {
    font-size: @font-md;
    margin-bottom: 20px;
}
.companyIntr-content {
    text-indent: 2em;
    line-height: 1.5em;
}
.carType-ctn {
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    min-height: 40px;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.carTypeItem {
    padding: 0 5px;
    height: 24px;
    line-height: 24px;
    border: 1px solid @theme;
    color: @theme;
    margin: 5px;
}
.carTypeItem-show {
    display: inline-block;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.car-del-btn {
    cursor: pointer;
}
</style>
